<template>
  <div :class="[{ 'pm__option-seperator-wrapper': isOptionSeperator }]">
    <div v-for="(priceGroup, groupIndex) in group" :key="groupIndex" class="pm__option-seperator">
      <span v-if="isOptionSeperator && showPrice" class="pm__optionPrice">{{ formatPrice(priceGroup.price) }}</span>
      <div class="pm__innerOptions">
        <button
          v-for="(optionValue, index) in priceGroup.options"
          :key="index"
          :class="[
            'pm__option-item',
            {
              'pm__option-item-swatch': isImageTypeSwatch && optionValue.image,
              'pm__option-item-image': !isImageTypeSwatch && optionValue.image,
            },
            { selected: optionValue.value === selectedOptions[optionName] },
            { 'is--onesize': optionValue.value.toLowerCase() === 'one size' },
          ]"
          data-stio-gtm-id="PDP: Color Option"
          data-color-swatch
          :data-available="isImageTypeSwatch ? true : optionValue.available"
          :disabled="hideUnavailableOption ? !optionValue.available : false"
          @click="() => updateSelection(optionName, optionValue.value, optionValue)"
          :aria-label="`option: ${optionName} ${getModifiedOptionName(optionName, optionValue.value)}`"
          :aria-pressed="optionValue.value === selectedOptions[optionName]"
          :aria-disabled="!optionValue.available"
        >
          <ImageField
            v-if="optionValue.image"
            :key="optionValue.image"
            :obj="{ url: optionValue.image, alt: optionValue.value, width: isImageTypeSwatch ? 44 : 288, height: isImageTypeSwatch ? 44 : 356 }"
          />
          <span v-else class="pm__option-item-name">
            {{ getModifiedOptionName(optionName, optionValue.value) }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import ImageField from '../../../global/image.vue';

  const props = defineProps({
    group: Array,
    optionName: String,
    selectedOptions: Object,
    hideUnavailableOption: Boolean,
    isOptionSeperator: Boolean,
    updateSelection: Function,
    formatPrice: Function,
    getModifiedOptionName: Function,
    isImageTypeSwatch: Boolean,
  });

  const showPrice = computed(() => {
    if (!props.group || props.group.length === 0) return false;

    const allPrices = new Set();

    props.group.forEach(groupItem => {
      allPrices.add(groupItem.price);
    });

    // Return true if there are different prices (more than one unique price)
    return allPrices.size > 1;
  });
  
</script>
